function initSocialShare() {
  document.querySelectorAll('[data-social-share]').forEach(root => {
    if (root._socialShareBound) return;
    root._socialShareBound = true;

    // ボタンの表示/非表示を制御
    const enabledTypes = root.getAttribute('data-social-share-enabled');
    if (enabledTypes !== null) {
      const enabledArray = enabledTypes.split(',').map(type => type.trim());
      const buttons = root.querySelectorAll('[data-social-share-type]');

      buttons.forEach(button => {
        const buttonType = button.getAttribute('data-social-share-type');
        
        if (enabledArray.includes(buttonType)) {
          // 有効なボタンを表示
          button.style.display = '';
          button.removeAttribute('hidden');
        } else {
          // 無効なボタンを非表示
          button.style.display = 'none';
          button.setAttribute('hidden', '');
        }
      });
    }

    const link = root.getAttribute('data-social-share-link') || location.href;
    const title = root.getAttribute('data-social-share-title') || document.title;

    root.addEventListener('click', e => {
      const btn = e.target.closest('[data-social-share-type]');
      if (!btn) return;
      e.preventDefault();

      const type = btn.getAttribute('data-social-share-type');
      const u = encodeURIComponent(link);
      const t = encodeURIComponent(title);

      const map = {
        x: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
        reddit: `https://www.reddit.com/submit?url=${u}&title=${t}`,
        telegram: `https://t.me/share/url?url=${u}&text=${t}`,
        whatsapp: `https://api.whatsapp.com/send?text=${t}%20${u}`,
        mail: `mailto:?subject=${t}&body=${t}%0A%0A${u}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
        pinterest: `https://www.pinterest.com/pin/create/button/?url=${u}&description=${t}`,
      };

      if (type === 'clipboard') {
        navigator.clipboard.writeText(link).then(() => {
          btn.classList.add('is--copied');
          setTimeout(() => btn.classList.remove('is--copied'), 2000);
        });
        return;
      }

      const url = map[type];
      if (url) window.open(url, '_blank', 'noopener,noreferrer');
    });
  });
}

// ボタンの表示/非表示を動的に更新する関数
function updateSocialShareButtons(container, enabledTypes) {
  if (typeof container === 'string') {
    container = document.querySelector(container);
  }
  
  if (!container) return;

  container.setAttribute('data-social-share-enabled', enabledTypes);
  
  // 再初期化
  container._socialShareBound = false;
  initSocialShare();
}

// Initialize Social Share
document.addEventListener('DOMContentLoaded', () => {
  initSocialShare();
});